var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"esc_detail_btn",class:_vm.btnClassProxy,style:(_vm.btnStyles),on:{"click":_vm.onClick}},[(_vm.iconName)?_c('span',{staticClass:"button-with-icon-custom-icon",domProps:{"innerHTML":_vm._s(_vm.getIconByKey(_vm.iconName, {
            class: _vm.iconClassProxy,
            style: _vm.iconStyle}))}}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }